module.exports = __webpack_public_path__ + "img/WhatsApp Image 2021-09-14 at 12.00.20 PM.9ef3f035.jpeg";